module.exports = __webpack_public_path__ + "static/media/sn.d2bec7ef.svg";